"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOSAndName = void 0;
const ua_parser_js_1 = require("ua-parser-js");
function getOSAndName() {
    const parser = new ua_parser_js_1.UAParser();
    const result = parser.getResult();
    return {
        os: result.os.name,
        osVersion: result.os.version,
        deviceName: result.browser.name,
        deviceVersion: result.browser.version,
    };
}
exports.getOSAndName = getOSAndName;
